import type { useProgress } from '@hooks/useProgress'
import type { Entity } from '@models/Entity'

import { apiClient, requestS3 } from '../../../gateways/api'
import type { UploadFile } from '../types/UploadFile'

import { completeAssignedBijlageForEntity } from './completeAssignedBijlageForEntity'

export { uploadBijlagenForEntity }

const uploadBijlagenForEntity = async ({
  entity,
  selectedFiles,
  progress,
  id,
  opleveren,
  assignedTo,
  documentsoort,
}: {
  entity: Entity
  selectedFiles: UploadFile[]
  progress: ReturnType<typeof useProgress>
  id?: string
  opleveren?: boolean
  assignedTo?: string
  documentsoort?: string
}) => {
  const { type, id: entityId } = entity
  const STATUS_UPLOADED = 'uploaded'

  const url = `/rest/${type}/${entityId}${
    id ? `/bijlageassigned/${id}` : ''
  }/bijlage`

  progress.set({
    current: progress.current,
    error: progress.error,
    total: progress.total,
  })

  try {
    for (const selectedFile of selectedFiles) {
      const data = {
        naam: selectedFile.name,
        omschrijving: selectedFile.omschrijving,
        ...(documentsoort && { documentsoort }),
      }

      progress.bump()

      const { data: saveResult } = await apiClient({
        url,
        method: 'POST',
        data,
      })

      const { url: uploadUrl } = saveResult.uploadData

      await requestS3({
        url: uploadUrl,
        method: 'PUT',
        data: selectedFile.file,
      })

      const { _id } = saveResult.databaseData

      await apiClient({
        url: `${url}/${_id}`,
        method: 'PATCH',
        data: { status: STATUS_UPLOADED },
      })
    }

    if (id) {
      if (opleveren) {
        await completeAssignedBijlageForEntity({ entity, id, assignedTo })
      }
    }
  } catch (error: any) {
    progress.fail()
    throw error
  }
}
